import { useRef, useCallback, useEffect } from "react";

interface UseDateTimeHandlerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedValue: Date | null;
  onChange: (date: Date) => void;
}

export const useDateTimeHandler = ({
  isOpen,
  onOpenChange,
  selectedValue,
  onChange,
}: UseDateTimeHandlerProps) => {
  const processingRef = useRef(false);

  const handleKeyDownCapture = useCallback((event: React.KeyboardEvent<HTMLDivElement>) => {
    // 방향키와 Enter는 DatePicker 내부 처리를 위해 허용
    if (
      event.key === "ArrowUp" ||
      event.key === "ArrowDown" ||
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Enter"
    ) {
      return; // 이벤트 전파 허용
    }

    // ESC 등 다른 키들만 차단
    event.stopPropagation();
  }, []);

  const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  }, []);

  const handleMouseDown = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  }, []);

  const handleWrapperKeyDown = useCallback((event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      event.stopPropagation(); // TaskDetail로 버블링 차단
    }
  }, []);

  const handleWrapperClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  }, []);

  useEffect(() => {
    if (!isOpen) {
      processingRef.current = false;
    }
  }, [isOpen]);

  return {
    handleKeyDownCapture,
    handleClick,
    handleMouseDown,
    handleWrapperKeyDown,
    handleWrapperClick,
  };
};
